import image from "../../img/debata.jpg";
import React from "react";
import { All, Button, LP, PP } from "./Style";
import styled from "styled-components";

const Paragraf = styled.p`
  font-size: 3vh;
  @media screen and (max-width: 479px) {
    font-size: 1.5rem;
  }
`;
export default function Debata() {
  return (
    <All>
      <LP zrodlo={image}></LP>
      <PP>
        <h1>Film na debatę szkolną</h1>
        <Paragraf>
          Film użyty jako materiał otwierający debatę szkolną pt."Otwarte
          systemy operacyjne są przyszłością."
        </Paragraf>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://youtu.be/dNJAoFnAudc"
        >
          <Button>Zobacz</Button>
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.facebook.com/zstiomechaniktg/posts/524831973098383"
        >
          <Button>Zdjęcia z debaty</Button>
        </a>
      </PP>
    </All>
  );
}
